import React, { Component } from 'react';
import { Button, Row, Col, Input, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../../components/Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';

class CreateAdvisor extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.state = {
            sec: '',
            isLoading: false,
            primaryBusinessName: '',
            advisors: [],
            unsavedChanges: false
        }
    };

    componentDidMount = () => {
        this.getAdvisors();
    }

    getAdvisors = () => {
        const json_request = JSON.stringify({ sec_number: '999-', auth0: this.props.user });
        this.setState({ isLoading: true }, () => {

            fetch('/api/advancedSearch/', {
                method: 'POST',
                body: json_request,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    const advisors = Array.isArray(results.rows) ? results.rows : [];
                    this.setState({
                        isLoading: false,
                        advisors,
                        unsavedChanges: false
                    }, () => this.getNextSECNumber())
                })
                .catch(() => {
                    this.setState({
                        isLoading: false,
                        advisors: [],
                        unsavedChanges: false
                    }, () => this.getNextSECNumber())
                })
        });
    }

    getNextSECNumber = () => {
        const advisors = Array.isArray(this.state.advisors) ? this.state.advisors : [];
        const value = advisors
            .map(item => item['SEC#'])
            .filter(item => parseInt(item?.split('-').shift()) === 999)
            .map(item => parseInt(item?.split('-').pop()))
            .filter(item => !isNaN(item))
            .sort((a, b) => b - a)[0] + 10;
        this.setState({
            sec: '999-' + String(!isNaN(value) ? value : 10)
        })
    }

    handleSubmit = () => {
        if (String(this.state.primaryBusinessName || '').trim() === '') return;

        const payload = {
            ...this.state,
            primaryBusinessName: String(this.state.primaryBusinessName || '').trim(),
        };

        fetch('/api/demographics/', {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.success) {
                    const newSec = String(results.data || '').trim();
                    this.setState({
                        sec: '',
                        unsavedChanges: false,
                        primaryBusinessName: ''
                    }, () => {
                        this.getAdvisors();

                        if (newSec) {
                            localStorage.setItem('demographicsActiveTab', 2);
                            this.props.history.push({
                                pathname: '/demographics/' + newSec,
                                state: { currentDate: '000000' }
                            });
                        }
                    });
                }
            })
    }

    handleDelete = (sec) => {
        fetch('/api/demographics/' + sec, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.data) {
                    this.getAdvisors();
                }
            })
    }

    render() {
        const hasBusinessName = String(this.state.primaryBusinessName || '').trim() !== '';
        return (
            <Row>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <Col>
                    <Row>
                        <Col md={4}>
                            <Label>SEC / ID# <Input type="text" name="sec" value={this.state.sec} onChange={(e) => this.setState({ sec: e.target.value, unsavedChanges: true })}></Input></Label>
                        </Col>
                        <Col>
                            <Label>Business Name <Input type="text" name="primaryBusinessName" value={this.state.primaryBusinessName} onChange={(e) => this.setState({ primaryBusinessName: e.target.value, unsavedChanges: true })}></Input></Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button className="mt-4" disabled={this.state.sec === '' || !hasBusinessName} color="primary" onClick={this.handleSubmit}>Submit</Button>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    {this.state.isLoading ? (<h5 className='pt-4'>Loading user-created companies...</h5>) :
                        [...(Array.isArray(this.state.advisors) ? this.state.advisors : [])].sort((a, b) => {
                            var textA = a['Primary Business Name']?.toUpperCase();
                            var textB = b['Primary Business Name']?.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        }).map(advisor => (
                            <Row key={advisor['SEC#']} className="text-left mt-3">
                                <Col md={4}>
                                    <Link
                                        onClick={() => localStorage.setItem('demographicsActiveTab', 2)}
                                        to={{ pathname: '/demographics/' + advisor['SEC#'], state: { currentDate: '000000' } }}
                                    >
                                        {advisor['SEC#']}
                                    </Link>
                                </Col>
                                <Col md={6}>
                                    {advisor['Primary Business Name'] !== '' ? advisor['Primary Business Name'] : 'Awaiting Input'}
                                </Col>
                                <Col md={2}>
                                    <ConfirmButton className="mx-1" color="danger" onClick={() => this.handleDelete(advisor['SEC#'])} title="Delete Company">
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                    </ConfirmButton>
                                </Col>
                            </Row>
                        ))
                    }
                </Col>
            </Row>
        );
    }
}

export default CreateAdvisor;
